import { getData } from "./url-request";
import { getAuthenticatedUser } from "./auth-session";

// Share only an in-flight read for the exact authenticated account snapshot.
// Do not cache results or carry requests across sign-in or firm changes.
let pending = null;
export function getGettingStartedStatus() {
  const account = getAuthenticatedUser();
  if (pending && pending.account === account) return pending.promise;
  const entry = { account, promise: null };
  entry.promise = getData("/me/getting-started").finally(() => {
    if (pending === entry) pending = null;
  });
  pending = entry;
  return entry.promise;
}
